exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".EmailVerifcationPage_page_container{display:flex;justify-content:center}.EmailVerifcationPage_content_container{display:flex;flex-direction:column;justify-content:center;margin-top:30px;padding:30px;border:1px solid black;border-radius:5px;align-self:center}.EmailVerifcationPage_logo_image{margin-bottom:20px;width:50px;height:50px;align-self:center}\n", ""]);

// Exports
exports.locals = {
	"page_container": "EmailVerifcationPage_page_container",
	"content_container": "EmailVerifcationPage_content_container",
	"logo_image": "EmailVerifcationPage_logo_image"
};